import React, { FC, ReactElement, useState } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import Tabs from "../tabs/tabs";
import GeneralMobileTab from "./generalMobileTab";
import HIDPresetMobileTab from "./hidPresetMobileTab";
import StidPresetMobileTab from "./stidPresetMobileTab";

const PresetMobile: FC = () => {
    const { translate } = useLocale();
    const tabs = [
        { label: translate.byKey(TranslationKeys.general), badge: 0, showInitial: true, isActive: true },
        { label: translate.byKey(TranslationKeys.stidMobile), badge: 0, showInitial: true, isActive: true },
        { label: translate.byKey(TranslationKeys.hidMobileAccess), badge: 0, showInitial: false, isActive: true }
    ];
    const [selectedTab, setSelectedTab] = useState(0);
    const tabConent: ReactElement[] = [
        <GeneralMobileTab />,
        <StidPresetMobileTab />,
        <HIDPresetMobileTab />
    ]

    return <div className="flex flex-col flex-grow bg-white h-full">
        <Tabs tabs={tabs}
            onSelect={setSelectedTab}
            selected={selectedTab}
            add={false} onAdd={() => { }}
            isFlat={true}
            setSelectedTab={setSelectedTab}
            className="w-full h-full"
            showBorder={false}>
            {tabConent[selectedTab]}
        </Tabs>
    </div>
}

export default PresetMobile;